import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from './AuthContext';
import { Button, Select } from '../../GlobalStyles';
import { PageTitle } from '../PageStyles';
import LoadingOverlay from '../Spinner/LoadingOverlay';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
`;

const Content = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

const Description = styled.p`
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
`;

const SelectContainer = styled.div`
  margin-bottom: 2rem;
`;

const SelectLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #333;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;


const ProjectSelector: React.FC = () => {
    const { authorization, setSelectedProject } = useAuth();
    const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);

    if (!authorization) {
        return (
            <Container>
                {!authorization && (<LoadingOverlay message="Authorizing..." />)}
            </Container>
        );
    }

    if (!authorization || !authorization.projects || authorization.projects.filter(p => p.enablePcar === true).length === 0) {
        return (
            <Container>
                <Content>
                    <PageTitle>No Projects Available</PageTitle>
                    <Description>
                        You don't have access to any projects. Please contact your administrator.
                    </Description>
                </Content>
            </Container>
        );
    }

    const pcarProjects = authorization.projects.filter(p => p.enablePcar === true);

    const handleProjectSelect = () => {
        if (selectedProjectId) {
            const project = pcarProjects.find(p => p.projectId === selectedProjectId);
            if (project) {
                setSelectedProject({
                    projectId: project.projectId,
                    projectName: project.projectName,
                    dbname: project.projectDatabaseName,
                    role: project.role,
                    readonly: project.readonly,
                    showSubstantive: project.showSubstantive || true,
                });
            }
        }
    };

    return (
        <Container>
            <Content>
                <PageTitle>Select Project</PageTitle>
                <Description>
                    Please select the project you want to work with. This selection will be remembered for future sessions.
                </Description>

                <SelectContainer>
                    <SelectLabel htmlFor="project-select">Available Projects:</SelectLabel>
                    <Select
                        id="project-select"
                        value={selectedProjectId || ''}
                        onChange={(e) => setSelectedProjectId(Number(e.target.value))}
                    >
                        <option value="">-- Select a Project --</option>
                        {pcarProjects.map(project => (
                            <option key={project.projectId} value={project.projectId}>
                                {project.projectName} ({project.role})
                            </option>
                        ))}
                    </Select>
                </SelectContainer>

                <ButtonContainer>
                    <Button
                        onClick={handleProjectSelect}
                        disabled={!selectedProjectId}
                    >
                        Continue
                    </Button>
                </ButtonContainer>
            </Content>
        </Container>
    );
};

export default ProjectSelector;
